// extracted by mini-css-extract-plugin
module.exports = {"linkList":"linkList-module--linkList--3WAL_","link":"linkList-module--link--owVqc","selected":"linkList-module--selected--10ZyV"};